import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import { Error as ErrorIcon } from "@material-ui/icons";
import { toast } from "react-toastify";

import { API } from "shared/services";

function FailSendMessage({ customer, message }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [sending, setSending] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const cancelMessage = () => {
    setSending(true);

    API.delete(`customers/${customer.id}/messages/${message.id}`)
      .then(() => setAnchorEl(null))
      .catch(() => toast.error("Erro ao remover a mensagem"))
      .finally(() => setSending(false));
  };

  const sendMessageAgain = () => {
    setSending(true);

    API.post(`customers/${customer.id}/messages/${message.id}/retry`)
      .then(() => setAnchorEl(null))
      .catch(() => toast.error("Erro ao enviar a mensagem"))
      .finally(() => setSending(false));
  };

  if (sending) return <></>;

  return (
    <>
      <IconButton color="secondary" variant="outlined" onClick={handleClick}>
        <ErrorIcon fontSize="large" />
      </IconButton>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={sendMessageAgain}>Tentar novamente</MenuItem>
        <MenuItem onClick={cancelMessage}>Cancelar</MenuItem>
      </Menu>
    </>
  );
}
export default FailSendMessage;
